'use client'

import { Button } from '@/components/ui/button'
import { IconBoltOff, IconBug, IconRefresh } from '@tabler/icons-react'
import Link from 'next/link'
// React
import { useEffect } from 'react'

export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  const handleReset = () => reset()

  useEffect(() => {
    console.error(error)
  })

  return (
    <div className="flex justify-center items-center bg-background w-full h-screen">
      <div className="text-foreground text-center">
        <IconBoltOff
          size={48}
          stroke={1}
          className="mx-auto mb-4"
        />

        <h1 className="mb-2 font-black text-2xl">It looks like there was a problem!</h1>
        <p className="mx-auto w-2/5 text-muted-foreground">
          We have a problem with that feature. Please submit a Bug Report using the button below, or try again.
        </p>

        <div className="flex flex-col justify-center items-center gap-4 mt-12">
          <Button onClick={handleReset}>
            <IconRefresh />
            <span>Try again</span>
          </Button>

          <Link href="/dashboard/submit-a-bug-report">
            <Button variant="ghost">
              <IconBug />
              <span>Submit a Bug Report</span>
            </Button>
          </Link>
        </div>
      </div>
    </div>
  )
}
